import { IconButton, Tooltip } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import { palette } from 'configurations/styles/theme';

const ModulesBtn = () => {
    const history = useHistory();

    return (
        <Tooltip title={`Módulos`}>
            <IconButton onClick={() => history.push("/modulos")}>
                <HomeOutlinedIcon style={{ color: palette.primary.menuHeader }} />
            </IconButton>
        </Tooltip>
    );
}

export default ModulesBtn;
